"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApolloTransaction = void 0;
var tslib_1 = require("tslib");
var lodashIsEqual = require("lodash.isequal");
var util_1 = require("../util");
var Queryable_1 = require("./Queryable");
function getOriginalFieldArguments(id) {
    // Split `${containerId}❖${JSON.stringify(path)}❖${JSON.stringify(args)}`
    var idComponents = id.split('❖');
    if (idComponents.length < 3) {
        return undefined;
    }
    return JSON.parse(idComponents[2]);
}
/**
 * Apollo-specific transaction interface.
 */
var ApolloTransaction = /** @class */ (function (_super) {
    tslib_1.__extends(ApolloTransaction, _super);
    function ApolloTransaction(
    /** The underlying transaction. */
    _queryable) {
        var _this = _super.call(this) || this;
        _this._queryable = _queryable;
        _this.updateListOfReferences = _this.updateParameterizedReferences;
        return _this;
    }
    ApolloTransaction.prototype.reset = function () {
        throw new Error("reset() is not allowed within a transaction");
    };
    ApolloTransaction.prototype.removeOptimistic = function (_id) {
        throw new Error("removeOptimistic() is not allowed within a transaction");
    };
    ApolloTransaction.prototype.performTransaction = function (transaction) {
        transaction(this);
    };
    ApolloTransaction.prototype.recordOptimisticTransaction = function (_transaction, _id) {
        throw new Error("recordOptimisticTransaction() is not allowed within a transaction");
    };
    ApolloTransaction.prototype.watch = function (_query) {
        throw new Error("watch() is not allowed within a transaction");
    };
    ApolloTransaction.prototype.restore = function () {
        throw new Error("restore() is not allowed within a transaction");
    };
    ApolloTransaction.prototype.extract = function () {
        throw new Error("extract() is not allowed within a transaction");
    };
    /**
     * A helper function to be used when doing EntityUpdate.
     * The method enable users to iterate different parameterized at an editPath
     * of a given container Id.
     *
     * The 'updateFieldCallback' is a callback to compute new value given previous
     * list of references and an object literal of parameterized arguments at the
     * given path.
     *
     * @param containerId {string} an id of a container node to look for editPath.
     * @param pathToParameterizedField {(string|number)[]} an array of paths to
     *    parameterized field in container.
     */
    ApolloTransaction.prototype.updateParameterizedReferences = function (containerId, pathToParameterizedField, _a, _b, updateFieldCallback) {
        var e_1, _c;
        var writeFragment = _a.writeFragment, writeFragmentName = _a.writeFragmentName;
        var readFragment = _b.readFragment, readFragmentName = _b.readFragmentName;
        var currentContainerNode = this._queryable.getCurrentNodeSnapshot(containerId);
        if (!currentContainerNode || !currentContainerNode.outbound) {
            return;
        }
        try {
            for (var _d = tslib_1.__values(currentContainerNode.outbound), _e = _d.next(); !_e.done; _e = _d.next()) {
                var _f = _e.value, outboundId = _f.id, path = _f.path;
                if (lodashIsEqual(pathToParameterizedField, path)) {
                    var fieldArguments = getOriginalFieldArguments(outboundId);
                    if (fieldArguments) {
                        var cacheResult = void 0;
                        try {
                            cacheResult = this.readFragment({
                                id: containerId,
                                fragment: readFragment,
                                fragmentName: readFragmentName,
                                variables: fieldArguments,
                            }, this._queryable.isOptimisticTransaction());
                        }
                        catch (error) {
                            continue;
                        }
                        var previousData = util_1.deepGet(cacheResult, path);
                        // if previousData is not object or null or array,
                        // we won't allow the field to be updated
                        if (!Array.isArray(previousData) && typeof previousData !== 'object') {
                            var details = util_1.verboseTypeof(previousData) + " at ContainerId " + containerId + " with readFragment " + readFragmentName;
                            throw new Error("updateParameterizedReferences() expects previousData to be an array or object instead got " + details);
                        }
                        var updateData = updateFieldCallback(previousData, fieldArguments);
                        if (updateData !== previousData) {
                            this.writeFragment({
                                id: outboundId,
                                fragment: writeFragment,
                                fragmentName: writeFragmentName,
                                variables: fieldArguments,
                                data: updateData,
                            });
                        }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return ApolloTransaction;
}(Queryable_1.ApolloQueryable));
exports.ApolloTransaction = ApolloTransaction;
//# sourceMappingURL=data:application/json;base64,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